import {
    buyerActions,
    buyerThunks as defaultThunks,
    buyerSelectors as defaultSelectors,
    buyerReducer,
} from './Buyer-slice';
import * as thunks from './Buyer-thunks';
import * as selectors from './Buyer-selectors';

const buyerThunks = { ...defaultThunks, ...thunks };
const buyerSelectors = { ...defaultSelectors, ...selectors };

export { buyerSelectors, buyerActions, buyerThunks, buyerReducer };
